import { Grid, Input, ListItem, ListItemText, TextField } from '@material-ui/core';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import FlatList from 'flatlist-react';
import CustomizedCircularProgress, { CustomizedCircularProgressLight } from './CircularProgress';
import crmservices from '../wsclient/';
import classNames from 'classnames'
import t from '../utils/translateUtil';
const WAIT_INTERVAL = 1000;
const styles = theme => ({
    inputRoot: {
        border: '1px solid',
        width: '80%',
        borderColor: theme.palette.border.secondary,
        borderRadius: theme.spacing(10),
        height: theme.spacing(11),
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.secondary,
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
       // marginTop: theme.spacing(1),
        alignItems: 'center',
        position: 'relative',
    },
    search_list:{
      backgroundColor: theme.palette.background.secondary,
      width: '98%',
      position: 'absolute',
      top:theme.spacing(8),
      left:'1%',
      borderBottomLeftRadius: theme.spacing(3),
      borderBottomRightRadius: theme.spacing(3),
      zIndex:999
  },
  search_list_show_top: {
    backgroundColor: theme.palette.background.secondary,
    width: '98%',
    position: 'absolute',
    bottom:theme.spacing(8),
    left:'1%',
    borderBottomLeftRadius: theme.spacing(3),
    borderBottomRightRadius: theme.spacing(3),
    zIndex:999
  },
  small:{
    marginLeft: theme.spacing(26),
    width: '80%'
  },
});

class MapInputComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: '',
      showListAddress: false,
      showLoadingAddress: false,
      listAddressLookUp: [],
      isChange:false
    }
    this.onHandleChange = this.onHandleChange.bind(this);
    this.onSelectAddress = this.onSelectAddress.bind(this);
}
  onHandleChange(value){
    console.log('MapInputComponent value=', value)
    if(value){
      clearTimeout(this.timer)
      this.setState({ address: value, isChange:true });
      this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
    }
    else{
      this.setState({ address: value,showListAddress:false,listAddressLookUp:[]});
    }
  }
  triggerChange = () => {
    this.onAddressLookup(this.state.address);
  }
  async onAddressLookup(address) {
    this.setState({ showListAddress: true, showLoadingAddress: true });
    var addresses = [];
    try {
        var result = await crmservices.contacts.findAddress({ address: address });
        if (result.code == 'OK') {
            addresses = result.data.content ? result.data.content : [];
        }
    } catch (error) {
        console.log("addresses lookup exception:", error);
    }
    this.setState({ showLoadingAddress:false,listAddressLookUp: addresses });
}
onSelectAddress(item){
  this.setState({showListAddress:false,isChange:false,listAddressLookUp:[]})
  this.props.onSelectAddress(item);
}
  render() {
      const {classes, defaultAddress, onHandleChange, isSelectBox, showTop, className} = this.props
      var { listAddressLookUp, showListAddress, showLoadingAddress,address,isChange } = this.state;
      //console.log("AA isChange:",isChange);
      //console.log("AA defaultAddress:",defaultAddress);
      //console.log("AA address:",address);
      if((!address && !isChange) || (address && !isChange)){
        address = defaultAddress;
    }
    return (
      <Grid item xs ={12} container className={classNames([classes.inputRoot]) }>
          <Input
            className={isSelectBox? classNames([classes.small, className]) :undefined}
            disableUnderline
            fullWidth
            placeholder={t('search_for')}
            value={address}
            name="search"
            onChange={(event)=>onHandleChange?onHandleChange(event.target.value):this.onHandleChange(event.target.value)}>
          </Input>
          {!this.state.showLoadingAddress&&this.state.showListAddress&&this.state.listAddressLookUp.length>0&&<Grid item className={showTop ? classes.search_list_show_top : classes.search_list}>
            <FlatList
              list={this.state.listAddressLookUp}
              renderItem={(item, index) =>
                <ListItem key={index} button onClick={()=>this.onSelectAddress(item)}>
                  <ListItemText primary={item.address}/>
                </ListItem>
              }
              />
          </Grid>}
          {this.state.showLoadingAddress&&<Grid item className={classes.search_list}>
            <CustomizedCircularProgressLight/>
          </Grid>}
          
      </Grid>
    );
  }
}
export default withStyles(styles)(withTranslation()(MapInputComponent))
